import { render, staticRenderFns } from "./theChampionship.vue?vue&type=template&id=9f91c5e6&scoped=true"
import script from "./theChampionship.vue?vue&type=script&lang=js"
export * from "./theChampionship.vue?vue&type=script&lang=js"
import style0 from "./theChampionship.vue?vue&type=style&index=0&id=9f91c5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f91c5e6",
  null
  
)

export default component.exports